import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDocumentMeta } from '../i18n/useDocumentMeta';
import { useLocalizedNav } from '../i18n/useLocalizedNav';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const { navigate } = useLocalizedNav();
  useDocumentMeta('notFound');

  const styles = {
    container: {
      minHeight: 'calc(100vh - 70px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 20px',
      textAlign: 'center',
    },
    errorCode: {
      fontSize: '120px',
      fontWeight: 'bold',
      color: '#2563eb',
      marginBottom: '20px',
      lineHeight: '1',
    },
    title: {
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#1f2937',
      marginBottom: '20px',
    },
    message: {
      fontSize: '18px',
      color: '#6b7280',
      marginBottom: '40px',
      maxWidth: '600px',
      lineHeight: '1.6',
    },
    buttonContainer: {
      display: 'flex',
      gap: '20px',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    button: {
      backgroundColor: '#2563eb',
      color: '#ffffff',
      padding: '12px 30px',
      fontSize: '16px',
      fontWeight: 'bold',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s',
    },
    buttonSecondary: {
      backgroundColor: 'transparent',
      color: '#2563eb',
      padding: '12px 30px',
      fontSize: '16px',
      fontWeight: 'bold',
      borderRadius: '8px',
      border: '2px solid #2563eb',
      cursor: 'pointer',
      transition: 'all 0.3s',
    },
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          @media (max-width: 768px) {
            .error-code-mobile {
              font-size: 80px !important;
            }
            .title-mobile {
              font-size: 24px !important;
            }
            .message-mobile {
              font-size: 16px !important;
            }
            .button-container-mobile {
              flex-direction: column !important;
              align-items: center !important;
            }
          }
        `}
      </style>
      
      <div style={styles.errorCode} className="error-code-mobile">404</div>
      <h1 style={styles.title} className="title-mobile">
        {t('notFound.title')}
      </h1>
      <p style={styles.message} className="message-mobile">
        {t('notFound.message1')}<br />
        {t('notFound.message2')}
      </p>
      
      <div style={styles.buttonContainer} className="button-container-mobile">
        <button
          onClick={() => navigate('/')}
          style={styles.button}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1e40af'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
        >
          {t('notFound.home')}
        </button>
        
        <button
          onClick={() => navigate('/news')}
          style={styles.buttonSecondary}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#2563eb';
            e.currentTarget.style.color = '#ffffff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#2563eb';
          }}
        >
          {t('notFound.news')}
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;